import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MapPin, Mail, Phone, Building2, ReceiptEuro } from 'lucide-react';
import { publicAPI } from '@/services/api';

export default function Footer() {
  const { t } = useTranslation();
  const [contact, setContact] = useState({
		company_email: 'info@equi-market.eu',
		company_phone: '+351 123 456 789',
		company_city: 'Lisbon',
		company_country: 'Portugal',
		company_name: 'Equi-Market',
		company_address: '',
		company_postal_code: ''
	});

  useEffect(() => {
    publicAPI.settings().then(r => {
      if (r.data) setContact(prev => ({ ...prev, ...r.data }));
    }).catch(() => {});
  }, []);

  const locationText = [
		contact.company_city,
		contact.company_country
	].filter(Boolean).join(', ') || 'Lisbon, Portugal';
  const addressText = [
		contact.company_address,
		contact.company_postal_code,
		locationText
	].filter(Boolean).join(', ');

  return (
    <footer className="bg-[#1A3C34] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <h3 className="text-2xl font-bold font-['Playfair_Display'] mb-4">
              Equi-<span className="text-[#D4C5A9]">Market</span>
            </h3>
            <p className="text-white/60 text-sm leading-relaxed mb-6">{t('footer.about_text')}</p>
            <div className="flex items-center gap-2 text-white/50 text-sm">
              <MapPin className="w-4 h-4" /> {locationText}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-[#D4C5A9] mb-4 col-span-2">
							{t('footer.quick_links')}
						</h4>
            <div className="space-y-2">
              <Link to="/horses" className="block text-sm text-white/60 hover:text-white transition-colors"
										onClick={() => window.scrollTo(0, 0)}>
								{t('nav.horses')}
							</Link>
              <Link to="/products" className="block text-sm text-white/60 hover:text-white transition-colors"
										onClick={() => window.scrollTo(0, 0)}>
								{t('nav.products')}
							</Link>
							<Link to="/transports" className="block text-sm text-white/60 hover:text-white transition-colors"
										onClick={() => window.scrollTo(0, 0)}>
								{t('nav.transports')}
							</Link>
							<Link to="/schools" className="block text-sm text-white/60 hover:text-white transition-colors"
										onClick={() => window.scrollTo(0, 0)}>
								{t('nav.schools')}
							</Link>
							<Link to="/stables" className="block text-sm text-white/60 hover:text-white transition-colors"
										onClick={() => window.scrollTo(0, 0)}>
								{t('nav.stables')}
							</Link>
							<Link to="/trainers" className="block text-sm text-white/60 hover:text-white transition-colors"
										onClick={() => window.scrollTo(0, 0)}>
								{t('nav.trainers')}
							</Link>
							<Link to="/events" className="block text-sm text-white/60 hover:text-white transition-colors"
										onClick={() => window.scrollTo(0, 0)}>
								{t('nav.events')}
							</Link>
							<Link to="/vets" className="block text-sm text-white/60 hover:text-white transition-colors"
										onClick={() => window.scrollTo(0, 0)}>
								{t('nav.vets')}
							</Link>
						</div>
					</div>
					<div>
						<h4 className="text-sm font-bold uppercase tracking-wider text-[#D4C5A9] mb-4">
							{t('nav.sell')}
						</h4>
						<div className="space-y-2">
							<Link to="/sell/horse" className="block text-sm text-white/60 hover:text-white transition-colors"
										onClick={() => window.scrollTo(0, 0)}>
								{t('horse.create_ad')}
							</Link>
							<Link to="/sell/product" className="block text-sm text-white/60 hover:text-white transition-colors"
										onClick={() => window.scrollTo(0, 0)}>
								{t('product.create_ad')}
							</Link>
							<Link to="/sell/transport" className="block text-sm text-white/60 hover:text-white transition-colors"
										onClick={() => window.scrollTo(0, 0)}>
								{t('transport.create_ad')}
							</Link>
							<Link to="/sell/school" className="block text-sm text-white/60 hover:text-white transition-colors"
										onClick={() => window.scrollTo(0, 0)}>
								{t('school.create_title')}
							</Link>
							<Link to="/sell/stable" className="block text-sm text-white/60 hover:text-white transition-colors"
										onClick={() => window.scrollTo(0, 0)}>
								{t('stable.create_title')}
							</Link>
							<Link to="/sell/trainer" className="block text-sm text-white/60 hover:text-white transition-colors"
										onClick={() => window.scrollTo(0, 0)}>
								{t('trainer.create_title')}
							</Link>
							<Link to="/sell/event" className="block text-sm text-white/60 hover:text-white transition-colors"
										onClick={() => window.scrollTo(0, 0)}>
								{t('event.create_title')}
							</Link>
							<Link to="/sell/vet" className="block text-sm text-white/60 hover:text-white transition-colors"
										onClick={() => window.scrollTo(0, 0)}>
								{t('vet.create_title')}
							</Link>
						</div>
					</div>

          {/* Legal */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-[#D4C5A9] mb-4">
							{t('footer.legal')}
						</h4>
            <div className="space-y-2">
							<Link to="/terms" className="block text-sm text-white/60 hover:text-white transition-colors"
										onClick={() => window.scrollTo(0, 0)}
										data-testid="footer-terms-link">
								{t('footer.terms')}
							</Link>
							<Link to="/privacy" className="block text-sm text-white/60 hover:text-white transition-colors"
										onClick={() => window.scrollTo(0, 0)}
										data-testid="footer-privacy-link">
								{t('footer.privacy')}
							</Link>
							<Link to="/gdpr" className="block text-sm text-white/60 hover:text-white transition-colors"
										onClick={() => window.scrollTo(0, 0)}
										data-testid="footer-gdpr-link">
								{t('legal.gdpr_title')}
							</Link>
							<a href="https://www.livroreclamacoes.pt/inicio/" target="_blank" rel="noopener noreferrer"
								 className="block text-sm text-white/60 hover:text-white transition-colors">
								{t('legal.complaints_book')}
							</a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-[#D4C5A9] mb-4">
							{t('footer.contact')}
						</h4>
            <div className="space-y-3">
              {contact.company_address && contact.company_address !== '' && (
                <div className="flex items-start gap-2 text-sm text-white/60" data-testid="footer-address">
                  <Building2 className="w-4 h-4 shrink-0 mt-0.5" /> <span>{addressText}</span>
                </div>
              )}
							{ contact.company_email && contact.company_email !== '' &&
								<div className="flex items-center gap-2 text-sm text-white/60" data-testid="footer-email">
									<Mail className="w-4 h-4" /> {contact.company_email || 'info@equi-market.eu'}
								</div>
							}
							{ contact.company_phone && contact.company_phone !== '' &&
								<div className="flex items-center gap-2 text-sm text-white/60" data-testid="footer-phone">
									<Phone className="w-4 h-4" /> {contact.company_phone || '+351 123 456 789'}
								</div>
							}
							{ contact.company_vat && contact.company_vat !== '' &&
								<div className="flex items-center gap-2 text-sm text-white/60" data-testid="footer-phone">
									<ReceiptEuro className="w-4 h-4" /> {contact.company_vat || '5123456789'}
								</div>
							}
							<Link to="/faq" className="block text-sm text-white/60 hover:text-white transition-colors"
										onClick={() => window.scrollTo(0, 0)}
										data-testid="footer-faq-link">
								{t('faq.title')}
							</Link>
							<Link to="/suggestions" className="block text-sm text-white/60 hover:text-white transition-colors"
										onClick={() => window.scrollTo(0, 0)}
										data-testid="footer-suggestions-link">
								{t('suggestions.title')}
							</Link>
						</div>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-white/40">
						&copy; {new Date().getFullYear()} Equi-Market. {t('footer.copyright')}
					</p>
          <p className="text-xs text-white/30">{t('footer.made_with_passion')}</p>
        </div>
      </div>
    </footer>
  );
}
